import { render, staticRenderFns } from "./groupfission.vue?vue&type=template&id=56face16&scoped=true"
import script from "./groupfission.vue?vue&type=script&lang=js"
export * from "./groupfission.vue?vue&type=script&lang=js"
import style0 from "./groupfission.vue?vue&type=style&index=0&id=56face16&prod&lang=less&scoped=true"
import style1 from "./groupfission.vue?vue&type=style&index=1&id=56face16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56face16",
  null
  
)

export default component.exports